import { EmploymentType, Gender, EmployeeClassification, PlacementType, CommissionType } from "../../../../../assets/data/enumData";

export const EMPLOYEE_FIELDS = [
  { label: "First Name", key: "firstName", type: "text" },
  { label: "Middle Name", key: "middleName", type: "text" },
  { label: "Last Name", key: "lastName", type: "text" },
  { label: "Email ID", key: "emailAddress", type: "text" },
  { label: "Alternate Email", key: "alternateEmailAddress", type: "text" },
  { label: "Phone Number", key: "contactNumber", type: "phone" },
  { label: "Job Title", key: "jobTitle", type: "text" },
  { label: "Start Date", key: "startDate", type: "datepicker" },
  { label: "Country", key: "address.country", type: "text" },
  { label: "Classification", key: "classification", type: "select", options: EmployeeClassification },
  { label: "Date of Birth", key: "dob", type: "datepicker" },
  { label: "Gender", key: "gender", type: "select", options: Gender },
  { label: "Employment Type", key: "employmentType", type: "select", options: EmploymentType },
  { label: "Address Line 1", key: "address.line1", type: "text" },
  { label: "Address Line 2", key: "address.line2", type: "text" },
  { label: "City", key: "address.city", type: "text" },
  { label: "State", key: "address.state", type: "text" },
  { label: "Zip Code", key: "address.zipCode", type: "text" },
];

export const CLIENT_FIELDS = [
  { label: "Legal Business Name", key: "legalBusinessName", type: "text" },
  { label: "Federal ID", key: "federalId", type: "text" },
  { label: "Net Terms", key: "netTerms", type: "select", options: [
    { label: "Net 30", value: 1 },
    { label: "Net 60", value: 2 },
    { label: "Net 90", value: 3 },
    { label: "Split(50-50)", value: 4 },
    { label: "Split(25-25-25-25)", value: 5 },
    { label: "Split(3 Equal Parts)", value: 6 },
  ]},
  { label: "Website", key: "website", type: "text" },
  { label: "Address Line 1", key: "address.line1", type: "text" },
  { label: "Address Line 2", key: "address.line2", type: "text" },
  { label: "City", key: "address.city", type: "text" },
  { label: "State", key: "address.state", type: "text" },
  { label: "Country", key: "address.country", type: "text" },
  { label: "Zip Code", key: "address.zipCode", type: "text" },
];

export const PLACEMENT_FIELDS = [
  { label: "Job Code", key: "jobCode", type: "text" },
  { label: "Placement Type", key: "placementType", type: "select", options: PlacementType },
  { label: "Commission Type", key: "commissionType", type: "select", options: CommissionType },
  { label: "Job Title", key: "jobTitle", type: "text" },
  { label: "Start Date", key: "startDate", type: "datepicker" },
  { label: "End Date", key: "endDate", type: "datepicker" },
  { label: "Offered Salary", key: "offeredSalary", type: "number" },
  { label: "Bill Rate", key: "billRate", type: "number" },
  { label: "Bill Type", key: "billType", type: "select", options: [
    { label: "Hourly", value: 1 },
    { label: "Daily", value: 2 },
    { label: "Weekly", value: 3 },
    { label: "Monthly", value: 4 },
    { label: "Annual", value: 5 },
  ]},
  { label: "Pay Rate", key: "payRate", type: "number" },
  { label: "Target Percentage", key: "targetPercentage", type: "number" },
  { label: "Target Amount", key: "targetAmount", type: "number" },
  { label: "Warranty Period", key: "warrantyPeriod", type: "select", options: [
    { label: "30 days", value: 1 },
    { label: "60 days", value: 2 },
    { label: "90 days", value: 3 },
    { label: "120 days", value: 4 },
  ]},
];
